import { usePaymentTemplate } from '@p2p/entities/templates';
import { ReactElement } from 'react';

type StepProps = {
  id: string;
  children: ReactElement | null;
};

export const Step = ({ children, id }: StepProps) => {
  const { stepId } = usePaymentTemplate();

  return stepId !== id ? null : children;
};
